<script setup lang="ts">
import type { Player } from '@/types'

defineProps<{
  currentRound: number
  totalRounds: number
  currentPlayer: Player | null
  isMyTurn: boolean
  timeLeft: number
  currentCategory: string
  currentWord: string
}>()
</script>

<template>
  <div class="flex flex-col items-center justify-center min-h-screen p-6">
    <div class="glass rounded-3xl p-6 max-w-md w-full text-center animate-fade-in">
      <div class="flex justify-between items-center mb-4">
        <span class="text-teal-200">Ronda {{ currentRound }}/{{ totalRounds }}</span>
        <span class="text-white font-bold text-2xl">{{ timeLeft }}s</span>
      </div>

      <!-- Pantalla para el jugador ACTIVO (mi turno) -->
      <div v-if="isMyTurn" class="active-player-screen">
        <div class="mb-6">
          <p class="text-teal-200 text-sm uppercase tracking-wide mb-2">Categoría</p>
          <p class="text-2xl font-bold text-accent">{{ currentCategory }}</p>
        </div>

        <div class="text-center mb-4">
          <p class="text-lg text-teal-200">Tu turno:</p>
          <p class="text-2xl font-bold text-white">{{ currentPlayer?.name || '...' }}</p>
        </div>

        <div
          id="word-display"
          class="bg-white/10 rounded-2xl p-8 mb-6 min-h-40 flex items-center justify-center"
        >
          <p class="text-4xl font-bold text-white text-center">
            {{ currentWord }}
          </p>
        </div>

        <p class="text-teal-200 text-sm">
          <span class="inline md:hidden">Doble tap = ¡Acerté! | Shake = Cambiar</span>
          <span class="hidden md:inline">Doble clic = ¡Acerté! | Espacio o S = Cambiar</span>
        </p>
      </div>

      <!-- Pantalla para ESPECTADORES (no es mi turno) -->
      <div v-else class="spectator-screen">
        <div class="bg-gradient-to-br from-purple-500/20 to-pink-500/20 rounded-2xl p-12 mb-6 min-h-60 flex items-center justify-center">
          <div class="text-center">
            <p class="text-2xl text-teal-200 mb-4">🎯 Están jugando:</p>
            <p class="text-5xl font-bold text-white mb-4">{{ currentPlayer?.name || '...' }}</p>
            <p class="text-lg text-teal-200">{{ currentCategory }}</p>
          </div>
        </div>

        <p class="text-teal-200 text-sm">
          Espera tu turno... 🎮
        </p>
      </div>
    </div>
  </div>
</template>
